import { render, staticRenderFns } from "./delete-case-pool.vue?vue&type=template&id=1442f672&scoped=true"
import script from "./delete-case-pool.vue?vue&type=script&lang=ts"
export * from "./delete-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442f672",
  null
  
)

export default component.exports